<template>
    <app-transition>
        <Dialog
            class="SetMessagesPriceError"
            :only-text="true"
            @close="handleClose"
        >
            <v-row text-center="">
                <v-col>
                  {{ $t('dialogs.set_messages_price_error') }}{{subscriptionPrice}}$
                </v-col>
            </v-row>

            <router-link
                :to="{name: 'user.setting.creator.subscription'}"
                style="text-transform: capitalize; text-decoration: underline;"
                class="mb-2"
            >
                {{ $t('dialogs.subscription_page') }}
            </router-link>
        </Dialog>
    </app-transition>
</template>

<script>
import Dialog from "@/components/app/form/Dialog";

export default {
    name: "SetMessagesPriceError",
    methods: {
        handleClose() {
            this.$emit('close');
        },
    },
    components: {
        Dialog,
    },
    props: {
        subscriptionPrice: {type: Number, default: null}
    }
}
</script>
